/** 请求域名 */
export const apiBase = 'https://app.jxschools.com';
export const API_VERSION = "m2227";
export const upload_url = "62ddf0e4eadde"

/** 微信登录appId */
export const wxAppId = "wx45f6df9ab21f4fdc";

export default {
  wxAppId,
  apiBase,
  uploadBaseUrl: `${apiBase}/api/${API_VERSION}/${upload_url}`,
  uploadHeader: {
    'user-token': localStorage.getItem('token')
  },
}